var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grade-data_detail",attrs:{"id":"GradeDataDetail"}},[_c('GradeDataDetailTable',{attrs:{"list":_vm.gradeList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }